import { useEffect } from "react"
import { Call } from "@twilio/voice-sdk"

export function useClosedCall(currentCall: Call, setCurrentCall: (call: Call | null) => void): void {
  useEffect(() => {
    function handleStatusChange(): void {
      if (currentCall.status() === "closed") {
        endCall()
      }
    }

    function endCall(): void {
      currentCall.disconnect()
      setCurrentCall(null)
    }

    if (currentCall) {
      currentCall.on("disconnect", endCall)
      currentCall.on("cancel", endCall)
      currentCall.on("error", endCall)

      handleStatusChange()

      return () => {
        currentCall.off("disconnect", handleStatusChange)
        currentCall.off("cancel", handleStatusChange)
        currentCall.off("error", handleStatusChange)
      }
    }
  }, [currentCall, setCurrentCall])
}
